/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  CreateApplicationDraft200Response,
  CreateApplicationDraft422Response,
  CreateApplicationDraftRequestMktuListInner,
  GetAddressSuggest401Response,
  GetAddressSuggest403Response,
  GetApplicationStatus200Response,
  GetApplicationStatus400Response,
  GetCommonState200Response,
  GetCommonState400Response,
  GetCommonState403Response,
  GetCommonState404Response,
  GetDataFirstStage200Response,
  GetDataFourthStage200Response,
  GetDataSecondStage200Response,
  GetDataThirdStage200Response,
  GetPaymentDocument422Response,
  GetPaymentStatus200Response,
  GetPaymentUrl200Response,
  GetPaymentUrl400Response,
  ImageSignType,
  OrganizationType,
  PublishApplication200Response,
  PublishApplication400Response,
  SaveDataFirstStage200Response,
  SaveDataFirstStage422Response,
  SaveDataFourthStage400Response,
  SaveDataFourthStage422Response,
  SaveDataFourthStageRequest,
  UpdateDataFirstStage200Response,
  UpdateDataFirstStage422Response,
  UpdateDataSecondStage422Response,
  UpdateDataSecondStageRequest,
  UploadReceipt400Response,
  UploadReceipt422Response,
} from '../models/index'
import {
  CreateApplicationDraft200ResponseFromJSON,
  CreateApplicationDraft200ResponseToJSON,
  CreateApplicationDraft422ResponseFromJSON,
  CreateApplicationDraft422ResponseToJSON,
  CreateApplicationDraftRequestMktuListInnerFromJSON,
  CreateApplicationDraftRequestMktuListInnerToJSON,
  GetAddressSuggest401ResponseFromJSON,
  GetAddressSuggest401ResponseToJSON,
  GetAddressSuggest403ResponseFromJSON,
  GetAddressSuggest403ResponseToJSON,
  GetApplicationStatus200ResponseFromJSON,
  GetApplicationStatus200ResponseToJSON,
  GetApplicationStatus400ResponseFromJSON,
  GetApplicationStatus400ResponseToJSON,
  GetCommonState200ResponseFromJSON,
  GetCommonState200ResponseToJSON,
  GetCommonState400ResponseFromJSON,
  GetCommonState400ResponseToJSON,
  GetCommonState403ResponseFromJSON,
  GetCommonState403ResponseToJSON,
  GetCommonState404ResponseFromJSON,
  GetCommonState404ResponseToJSON,
  GetDataFirstStage200ResponseFromJSON,
  GetDataFirstStage200ResponseToJSON,
  GetDataFourthStage200ResponseFromJSON,
  GetDataFourthStage200ResponseToJSON,
  GetDataSecondStage200ResponseFromJSON,
  GetDataSecondStage200ResponseToJSON,
  GetDataThirdStage200ResponseFromJSON,
  GetDataThirdStage200ResponseToJSON,
  GetPaymentDocument422ResponseFromJSON,
  GetPaymentDocument422ResponseToJSON,
  GetPaymentStatus200ResponseFromJSON,
  GetPaymentStatus200ResponseToJSON,
  GetPaymentUrl200ResponseFromJSON,
  GetPaymentUrl200ResponseToJSON,
  GetPaymentUrl400ResponseFromJSON,
  GetPaymentUrl400ResponseToJSON,
  ImageSignTypeFromJSON,
  ImageSignTypeToJSON,
  OrganizationTypeFromJSON,
  OrganizationTypeToJSON,
  PublishApplication200ResponseFromJSON,
  PublishApplication200ResponseToJSON,
  PublishApplication400ResponseFromJSON,
  PublishApplication400ResponseToJSON,
  SaveDataFirstStage200ResponseFromJSON,
  SaveDataFirstStage200ResponseToJSON,
  SaveDataFirstStage422ResponseFromJSON,
  SaveDataFirstStage422ResponseToJSON,
  SaveDataFourthStage400ResponseFromJSON,
  SaveDataFourthStage400ResponseToJSON,
  SaveDataFourthStage422ResponseFromJSON,
  SaveDataFourthStage422ResponseToJSON,
  SaveDataFourthStageRequestFromJSON,
  SaveDataFourthStageRequestToJSON,
  UpdateDataFirstStage200ResponseFromJSON,
  UpdateDataFirstStage200ResponseToJSON,
  UpdateDataFirstStage422ResponseFromJSON,
  UpdateDataFirstStage422ResponseToJSON,
  UpdateDataSecondStage422ResponseFromJSON,
  UpdateDataSecondStage422ResponseToJSON,
  UpdateDataSecondStageRequestFromJSON,
  UpdateDataSecondStageRequestToJSON,
  UploadReceipt400ResponseFromJSON,
  UploadReceipt400ResponseToJSON,
  UploadReceipt422ResponseFromJSON,
  UploadReceipt422ResponseToJSON,
} from '../models/index'

export interface CreateApplicationDraftRequest {
  isEqual: boolean
  customerOrganizationType: OrganizationType
  mktuList: Array<CreateApplicationDraftRequestMktuListInner>
  userUuid: string
  customerOrganizationDataInn?: string
  customerOrganizationDataSnils?: string
  customerOrganizationDataPassportSeriesNumber?: string
  customerOrganizationDataName?: string
  customerOrganizationDataAddress?: string
  customerOrganizationDataAddressCorrespondent?: string
  customerOrganizationDataNameTransliterate?: string
  customerOrganizationDataRegNumber?: string
  customerOrganizationDataTaxNumber?: string
  customerOrganizationDataCountryCode?: string
  customerOrganizationDataAddressTransliterate?: string
  ownerOrganizationType?: OrganizationType
  ownerOrganizationDataInn?: string
  ownerOrganizationDataSnils?: string
  ownerOrganizationDataPassportSeriesNumber?: string
  ownerOrganizationDataName?: string
  ownerOrganizationDataAddress?: string
  ownerOrganizationDataAddressCorrespondent?: string
  ownerOrganizationDataNameTransliterate?: string
  ownerOrganizationDataRegNumber?: string
  ownerOrganizationDataTaxNumber?: string
  ownerOrganizationDataCountryCode?: string
  ownerOrganizationDataAddressTransliterate?: string
  brand?: string
  file?: Blob
  imageSignType?: ImageSignType
  allowEmptyPersonalDocuments?: boolean | null
}

export interface GetApplicationStatusRequest {
  applicationId: string
}

export interface GetCommonStateRequest {
  applicationId: string
}

export interface GetDataFirstStageRequest {
  applicationId: string
}

export interface GetDataFourthStageRequest {
  applicationId: string
}

export interface GetDataSecondStageRequest {
  applicationId: string
}

export interface GetDataThirdStageRequest {
  applicationId: string
}

export interface GetPaymentDocumentRequest {
  applicationId: string
  type?: GetPaymentDocumentTypeEnum
}

export interface GetPaymentStatusRequest {
  applicationId: string
}

export interface GetPaymentUrlRequest {
  applicationId: string
}

export interface PassThirdStageRequest {
  applicationId: string
}

export interface PublishApplicationRequest {
  applicationId: string
}

export interface SaveDataFirstStageRequest {
  isEqual: boolean
  customerOrganizationType: OrganizationType
  customerOrganizationDataInn?: string
  customerOrganizationDataSnils?: string
  customerOrganizationDataPassportSeriesNumber?: string
  customerOrganizationDataName?: string
  customerOrganizationDataAddress?: string
  customerOrganizationDataAddressCorrespondent?: string
  customerOrganizationDataNameTransliterate?: string
  customerOrganizationDataRegNumber?: string
  customerOrganizationDataTaxNumber?: string
  customerOrganizationDataCountryCode?: string
  customerOrganizationDataAddressTransliterate?: string
  ownerOrganizationType?: OrganizationType
  ownerOrganizationDataInn?: string
  ownerOrganizationDataSnils?: string
  ownerOrganizationDataPassportSeriesNumber?: string
  ownerOrganizationDataName?: string
  ownerOrganizationDataAddress?: string
  ownerOrganizationDataAddressCorrespondent?: string
  ownerOrganizationDataNameTransliterate?: string
  ownerOrganizationDataRegNumber?: string
  ownerOrganizationDataTaxNumber?: string
  ownerOrganizationDataCountryCode?: string
  ownerOrganizationDataAddressTransliterate?: string
  brand?: string
  file?: Blob
  imageSignType?: ImageSignType
}

export interface SaveDataFourthStageOperationRequest {
  applicationId: string
  saveDataFourthStageRequest: SaveDataFourthStageRequest
}

export interface UpdateDataFirstStageRequest {
  applicationId: string
  isEqual: boolean
  customerOrganizationType: OrganizationType
  method?: string
  customerOrganizationDataInn?: string
  customerOrganizationDataSnils?: string
  customerOrganizationDataPassportSeriesNumber?: string
  customerOrganizationDataName?: string
  customerOrganizationDataAddress?: string
  customerOrganizationDataAddressCorrespondent?: string
  customerOrganizationDataNameTransliterate?: string
  customerOrganizationDataRegNumber?: string
  customerOrganizationDataTaxNumber?: string
  customerOrganizationDataCountryCode?: string
  customerOrganizationDataAddressTransliterate?: string
  ownerOrganizationType?: OrganizationType
  ownerOrganizationDataInn?: string
  ownerOrganizationDataSnils?: string
  ownerOrganizationDataPassportSeriesNumber?: string
  ownerOrganizationDataName?: string
  ownerOrganizationDataAddress?: string
  ownerOrganizationDataAddressCorrespondent?: string
  ownerOrganizationDataNameTransliterate?: string
  ownerOrganizationDataRegNumber?: string
  ownerOrganizationDataTaxNumber?: string
  ownerOrganizationDataCountryCode?: string
  ownerOrganizationDataAddressTransliterate?: string
  brand?: string | null
  file?: Blob | null
  imageSignType?: ImageSignType | null
}

export interface UpdateDataSecondStageOperationRequest {
  applicationId: string
  updateDataSecondStageRequest: UpdateDataSecondStageRequest
  method?: string
}

export interface UploadReceiptRequest {
  applicationId: string
  receipt: Blob
  method?: string
}

/**
 * CreateApplicationApi - interface
 *
 * @export
 * @interface CreateApplicationApiInterface
 */
export interface CreateApplicationApiInterface {
  /**
   * Внешнее создание черновика заявки сразу с данными 1 и 2 этапов (заказчик/правообладатель + знак + классы МКТУ) для указанного userUuid. Отсутствует в docs/api.yaml — operationId выбран по кодовой базе. Единственный эндпоинт группы applications без требования подтверждённого email.
   * @summary Внешнее создание черновика заявки
   * @param {boolean} isEqual Заказчик и правообладатель совпадают (при true блок owner* запрещён)
   * @param {OrganizationType} customerOrganizationType Тип организации заказчика
   * @param {Array<CreateApplicationDraftRequestMktuListInner>} mktuList Классы МКТУ 2 этапа (1–45 элементов)
   * @param {string} userUuid UUID пользователя, для которого создаётся черновик
   * @param {string} [customerOrganizationDataInn] ИНН заказчика (10 знаков — юрлицо, 12 — ИП/физлицо)
   * @param {string} [customerOrganizationDataSnils] СНИЛС заказчика (только INDIVIDUAL_ENTITY)
   * @param {string} [customerOrganizationDataPassportSeriesNumber] Серия и номер паспорта заказчика (только INDIVIDUAL_ENTITY)
   * @param {string} [customerOrganizationDataName] Наименование с кратким ОПФ
   * @param {string} [customerOrganizationDataAddress] Адрес с индексом, городом, улицей и квартирой
   * @param {string} [customerOrganizationDataAddressCorrespondent] Адрес для корреспонденции (произвольный формат)
   * @param {string} [customerOrganizationDataNameTransliterate] Транслитерированное наименование (только FOREIGN_COMPANY)
   * @param {string} [customerOrganizationDataRegNumber] Регистрационный номер (только FOREIGN_COMPANY)
   * @param {string} [customerOrganizationDataTaxNumber] Налоговый номер (только FOREIGN_COMPANY)
   * @param {string} [customerOrganizationDataCountryCode] Код страны из словаря (только FOREIGN_COMPANY)
   * @param {string} [customerOrganizationDataAddressTransliterate] Транслитерированный адрес (только FOREIGN_COMPANY)
   * @param {OrganizationType} [ownerOrganizationType] Тип организации правообладателя (обязателен при isEqual&#x3D;false)
   * @param {string} [ownerOrganizationDataInn] ИНН правообладателя; при isEqual&#x3D;true передавать запрещено
   * @param {string} [ownerOrganizationDataSnils] СНИЛС правообладателя (только INDIVIDUAL_ENTITY)
   * @param {string} [ownerOrganizationDataPassportSeriesNumber] Серия и номер паспорта правообладателя (только INDIVIDUAL_ENTITY)
   * @param {string} [ownerOrganizationDataName] Наименование правообладателя с кратким ОПФ
   * @param {string} [ownerOrganizationDataAddress] Адрес правообладателя
   * @param {string} [ownerOrganizationDataAddressCorrespondent] Адрес для корреспонденции правообладателя
   * @param {string} [ownerOrganizationDataNameTransliterate] Транслитерированное наименование (только FOREIGN_COMPANY)
   * @param {string} [ownerOrganizationDataRegNumber] Регистрационный номер (только FOREIGN_COMPANY)
   * @param {string} [ownerOrganizationDataTaxNumber] Налоговый номер (только FOREIGN_COMPANY)
   * @param {string} [ownerOrganizationDataCountryCode] Код страны из словаря (только FOREIGN_COMPANY)
   * @param {string} [ownerOrganizationDataAddressTransliterate] Транслитерированный адрес (только FOREIGN_COMPANY)
   * @param {string} [brand] Словесное наименование знака; исключён с file/imageSignType
   * @param {Blob} [file] Изображение знака (jpg/jpeg/png/tif/tiff/webp)
   * @param {ImageSignType} [imageSignType] Тип знака при загрузке файла: C — комбинированный, D — изобразительный
   * @param {boolean} [allowEmptyPersonalDocuments] Разрешить пустые СНИЛС/паспорт для заказчика-физлица
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreateApplicationApiInterface
   */
  createApplicationDraftRaw(
    requestParameters: CreateApplicationDraftRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CreateApplicationDraft200Response>>

  /**
   * Внешнее создание черновика заявки сразу с данными 1 и 2 этапов (заказчик/правообладатель + знак + классы МКТУ) для указанного userUuid. Отсутствует в docs/api.yaml — operationId выбран по кодовой базе. Единственный эндпоинт группы applications без требования подтверждённого email.
   * Внешнее создание черновика заявки
   */
  createApplicationDraft(
    requestParameters: CreateApplicationDraftRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CreateApplicationDraft200Response>

  /**
   * Статус последней записи истории проверок заявки (7 этап): статус проверки, признак оплаченной сервисной услуги, ссылка на итоговый документ полной проверки и номер счёта-договора. Статус AGREE_TO_RISKY — искусственный: второй круг после полной проверки, когда услуги на шаге 4 не выбраны (требуется показать предупреждение). Требуется подтверждённый email.
   * @summary Статус проверок заявки (7 этап)
   * @param {string} applicationId Порядковый номер заявления в системе
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreateApplicationApiInterface
   */
  getApplicationStatusRaw(
    requestParameters: GetApplicationStatusRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetApplicationStatus200Response>>

  /**
   * Статус последней записи истории проверок заявки (7 этап): статус проверки, признак оплаченной сервисной услуги, ссылка на итоговый документ полной проверки и номер счёта-договора. Статус AGREE_TO_RISKY — искусственный: второй круг после полной проверки, когда услуги на шаге 4 не выбраны (требуется показать предупреждение). Требуется подтверждённый email.
   * Статус проверок заявки (7 этап)
   */
  getApplicationStatus(
    requestParameters: GetApplicationStatusRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetApplicationStatus200Response>

  /**
   * Общее состояние заявки: пройденный и текущий этапы, изображение знака, статистика классов МКТУ, правообладатель, услуги из неоплаченного ордера и признак возможности удаления заявки. Поле linkInAdmin возвращается только админским аккаунтам. Требуется подтверждённый email.
   * @summary Общее состояние заявки
   * @param {string} applicationId Порядковый номер заявления в системе
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreateApplicationApiInterface
   */
  getCommonStateRaw(
    requestParameters: GetCommonStateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetCommonState200Response>>

  /**
   * Общее состояние заявки: пройденный и текущий этапы, изображение знака, статистика классов МКТУ, правообладатель, услуги из неоплаченного ордера и признак возможности удаления заявки. Поле linkInAdmin возвращается только админским аккаунтам. Требуется подтверждённый email.
   * Общее состояние заявки
   */
  getCommonState(
    requestParameters: GetCommonStateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetCommonState200Response>

  /**
   * Данные 1 этапа создания заявки: словесный знак либо изображение, признак совпадения заказчика и правообладателя, типы и данные организаций заказчика и правообладателя (схема ApplicationFirstStageData из docs/api.yaml). Состав полей organizationData зависит от типа организации; ненужные для типа поля отсутствуют. Требуется подтверждённый email.
   * @summary Данные 1 этапа заявки
   * @param {string} applicationId Порядковый номер заявления в системе
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreateApplicationApiInterface
   */
  getDataFirstStageRaw(
    requestParameters: GetDataFirstStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetDataFirstStage200Response>>

  /**
   * Данные 1 этапа создания заявки: словесный знак либо изображение, признак совпадения заказчика и правообладателя, типы и данные организаций заказчика и правообладателя (схема ApplicationFirstStageData из docs/api.yaml). Состав полей organizationData зависит от типа организации; ненужные для типа поля отсутствуют. Требуется подтверждённый email.
   * Данные 1 этапа заявки
   */
  getDataFirstStage(
    requestParameters: GetDataFirstStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetDataFirstStage200Response>

  /**
   * Список услуг, доступных для выбора в заявке (4 этап): группа регистрации (для админских аккаунтов — своя группа) с ценами в базовой валюте. serviceProductPaid=true, если по заявке уже есть оплаченный сервисный продукт — тогда на шаге разрешено не выбирать ни одной услуги. Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * @summary Услуги заявки (4 этап)
   * @param {string} applicationId Порядковый номер заявления в системе
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreateApplicationApiInterface
   */
  getDataFourthStageRaw(
    requestParameters: GetDataFourthStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetDataFourthStage200Response>>

  /**
   * Список услуг, доступных для выбора в заявке (4 этап): группа регистрации (для админских аккаунтов — своя группа) с ценами в базовой валюте. serviceProductPaid=true, если по заявке уже есть оплаченный сервисный продукт — тогда на шаге разрешено не выбирать ни одной услуги. Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * Услуги заявки (4 этап)
   */
  getDataFourthStage(
    requestParameters: GetDataFourthStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetDataFourthStage200Response>

  /**
   * Классы МКТУ, выбранные в заявке (2 этап): номера классов и наименования товаров/услуг (схема ApplicationSecondStageData из docs/api.yaml). Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * @summary МКТУ заявки (2 этап)
   * @param {string} applicationId Порядковый номер заявления в системе
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreateApplicationApiInterface
   */
  getDataSecondStageRaw(
    requestParameters: GetDataSecondStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetDataSecondStage200Response>>

  /**
   * Классы МКТУ, выбранные в заявке (2 этап): номера классов и наименования товаров/услуг (схема ApplicationSecondStageData из docs/api.yaml). Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * МКТУ заявки (2 этап)
   */
  getDataSecondStage(
    requestParameters: GetDataSecondStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetDataSecondStage200Response>

  /**
   * Предпросмотр всех данных заявки перед подтверждением подачи (3 этап): знак (brand либо изображение), заказчик/правообладатель и выбранные классы МКТУ (схема ApplicationThirdStageData из docs/api.yaml — данные 1 и 2 этапов вместе). Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * @summary Предпросмотр данных заявки (3 этап)
   * @param {string} applicationId Порядковый номер заявления в системе
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreateApplicationApiInterface
   */
  getDataThirdStageRaw(
    requestParameters: GetDataThirdStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetDataThirdStage200Response>>

  /**
   * Предпросмотр всех данных заявки перед подтверждением подачи (3 этап): знак (brand либо изображение), заказчик/правообладатель и выбранные классы МКТУ (схема ApplicationThirdStageData из docs/api.yaml — данные 1 и 2 этапов вместе). Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * Предпросмотр данных заявки (3 этап)
   */
  getDataThirdStage(
    requestParameters: GetDataThirdStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetDataThirdStage200Response>

  /**
   * Счёт-договор на оплату услуг подачи заявки (5 этап): PDF-файл отдаётся потоком (Content-Type и имя файла из документа), а не в конверте success_response. Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * @summary Счёт на оплату услуг (PDF)
   * @param {string} applicationId Порядковый номер заявления в системе
   * @param {'inline' | 'attachment'} [type] Тип Content-Disposition выдачи файла (по умолчанию inline)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreateApplicationApiInterface
   */
  getPaymentDocumentRaw(
    requestParameters: GetPaymentDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>>

  /**
   * Счёт-договор на оплату услуг подачи заявки (5 этап): PDF-файл отдаётся потоком (Content-Type и имя файла из документа), а не в конверте success_response. Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * Счёт на оплату услуг (PDF)
   */
  getPaymentDocument(
    requestParameters: GetPaymentDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob>

  /**
   * Статус оплаты последнего ордера на услуги подачи заявки (5 этап). Если неоплаченных ордеров нет либо банк подтвердил оплату, isOrderPayed=true и заявка переводится на nextStage = APPLICATION_STAGE_7 (fallback-обработка, если webhook банка ещё не пришёл). Требуется подтверждённый email.
   * @summary Статус оплаты услуг (5 этап)
   * @param {string} applicationId Порядковый номер заявления в системе
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreateApplicationApiInterface
   */
  getPaymentStatusRaw(
    requestParameters: GetPaymentStatusRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetPaymentStatus200Response>>

  /**
   * Статус оплаты последнего ордера на услуги подачи заявки (5 этап). Если неоплаченных ордеров нет либо банк подтвердил оплату, isOrderPayed=true и заявка переводится на nextStage = APPLICATION_STAGE_7 (fallback-обработка, если webhook банка ещё не пришёл). Требуется подтверждённый email.
   * Статус оплаты услуг (5 этап)
   */
  getPaymentStatus(
    requestParameters: GetPaymentStatusRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetPaymentStatus200Response>

  /**
   * Ссылка на оплату последнего неоплаченного ордера на услуги подачи заявки (6 этап): через платёжный шлюз, с возвратом на страницу заявки после оплаты. Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * @summary Ссылка на оплату услуг (6 этап)
   * @param {string} applicationId Порядковый номер заявления в системе
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreateApplicationApiInterface
   */
  getPaymentUrlRaw(
    requestParameters: GetPaymentUrlRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetPaymentUrl200Response>>

  /**
   * Ссылка на оплату последнего неоплаченного ордера на услуги подачи заявки (6 этап): через платёжный шлюз, с возвратом на страницу заявки после оплаты. Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * Ссылка на оплату услуг (6 этап)
   */
  getPaymentUrl(
    requestParameters: GetPaymentUrlRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetPaymentUrl200Response>

  /**
   * Подтверждение предпросмотра (3 этап пройден): заявка переводится на nextStage = APPLICATION_STAGE_4 (выбор услуг). Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * @summary Подтверждение 3 этапа
   * @param {string} applicationId Порядковый номер заявления в системе
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreateApplicationApiInterface
   */
  passThirdStageRaw(
    requestParameters: PassThirdStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UpdateDataFirstStage200Response>>

  /**
   * Подтверждение предпросмотра (3 этап пройден): заявка переводится на nextStage = APPLICATION_STAGE_4 (выбор услуг). Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * Подтверждение 3 этапа
   */
  passThirdStage(
    requestParameters: PassThirdStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UpdateDataFirstStage200Response>

  /**
   * Публикация заявки в делопроизводство (АРМ) после полной проверки: допускается при статусе последней полной проверки FULL_CHECK_LOW/MEDIUM/HIGH и оплаченной сервисной услуге. Требуется подтверждённый email.
   * @summary Публикация заявки (7 этап)
   * @param {string} applicationId Порядковый номер заявления в системе
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreateApplicationApiInterface
   */
  publishApplicationRaw(
    requestParameters: PublishApplicationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PublishApplication200Response>>

  /**
   * Публикация заявки в делопроизводство (АРМ) после полной проверки: допускается при статусе последней полной проверки FULL_CHECK_LOW/MEDIUM/HIGH и оплаченной сервисной услуге. Требуется подтверждённый email.
   * Публикация заявки (7 этап)
   */
  publishApplication(
    requestParameters: PublishApplicationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PublishApplication200Response>

  /**
   * Создание новой заявки: данные заказчика и правообладателя (1 этап) + словесное наименование знака (brand) либо файл изображения (file + imageSignType). При isEqual=true блок правообладателя не передаётся (запрещён). Заявка создаётся сразу со stage1 пройденным, nextStage = APPLICATION_STAGE_2; для не-админских аккаунтов регистрируется лид в AmoCRM. Требуется подтверждённый email.
   * @summary Создание заявки (1 этап)
   * @param {boolean} isEqual Заказчик и правообладатель совпадают (при true блок owner* запрещён)
   * @param {OrganizationType} customerOrganizationType Тип организации заказчика
   * @param {string} [customerOrganizationDataInn] ИНН заказчика (10 знаков — юрлицо, 12 — ИП/физлицо)
   * @param {string} [customerOrganizationDataSnils] СНИЛС заказчика (только INDIVIDUAL_ENTITY)
   * @param {string} [customerOrganizationDataPassportSeriesNumber] Серия и номер паспорта заказчика (только INDIVIDUAL_ENTITY)
   * @param {string} [customerOrganizationDataName] Наименование с кратким ОПФ
   * @param {string} [customerOrganizationDataAddress] Адрес с индексом, городом, улицей и квартирой
   * @param {string} [customerOrganizationDataAddressCorrespondent] Адрес для корреспонденции (произвольный формат)
   * @param {string} [customerOrganizationDataNameTransliterate] Транслитерированное наименование (только FOREIGN_COMPANY)
   * @param {string} [customerOrganizationDataRegNumber] Регистрационный номер (только FOREIGN_COMPANY)
   * @param {string} [customerOrganizationDataTaxNumber] Налоговый номер (только FOREIGN_COMPANY)
   * @param {string} [customerOrganizationDataCountryCode] Код страны из словаря (только FOREIGN_COMPANY)
   * @param {string} [customerOrganizationDataAddressTransliterate] Транслитерированный адрес (только FOREIGN_COMPANY)
   * @param {OrganizationType} [ownerOrganizationType] Тип организации правообладателя (обязателен при isEqual&#x3D;false)
   * @param {string} [ownerOrganizationDataInn] ИНН правообладателя; при isEqual&#x3D;true передавать запрещено
   * @param {string} [ownerOrganizationDataSnils] СНИЛС правообладателя (только INDIVIDUAL_ENTITY)
   * @param {string} [ownerOrganizationDataPassportSeriesNumber] Серия и номер паспорта правообладателя (только INDIVIDUAL_ENTITY)
   * @param {string} [ownerOrganizationDataName] Наименование правообладателя с кратким ОПФ
   * @param {string} [ownerOrganizationDataAddress] Адрес правообладателя
   * @param {string} [ownerOrganizationDataAddressCorrespondent] Адрес для корреспонденции правообладателя
   * @param {string} [ownerOrganizationDataNameTransliterate] Транслитерированное наименование (только FOREIGN_COMPANY)
   * @param {string} [ownerOrganizationDataRegNumber] Регистрационный номер (только FOREIGN_COMPANY)
   * @param {string} [ownerOrganizationDataTaxNumber] Налоговый номер (только FOREIGN_COMPANY)
   * @param {string} [ownerOrganizationDataCountryCode] Код страны из словаря (только FOREIGN_COMPANY)
   * @param {string} [ownerOrganizationDataAddressTransliterate] Транслитерированный адрес (только FOREIGN_COMPANY)
   * @param {string} [brand] Словесное наименование знака; исключён с file/imageSignType (обязателен, если они пусты)
   * @param {Blob} [file] Изображение знака (jpg/jpeg/png/tif/tiff/webp, размер — по настройкам сервера); обязателен, если brand пуст
   * @param {ImageSignType} [imageSignType] Тип заявляемого знака при загрузке файла: C — комбинированный, D — изобразительный
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreateApplicationApiInterface
   */
  saveDataFirstStageRaw(
    requestParameters: SaveDataFirstStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SaveDataFirstStage200Response>>

  /**
   * Создание новой заявки: данные заказчика и правообладателя (1 этап) + словесное наименование знака (brand) либо файл изображения (file + imageSignType). При isEqual=true блок правообладателя не передаётся (запрещён). Заявка создаётся сразу со stage1 пройденным, nextStage = APPLICATION_STAGE_2; для не-админских аккаунтов регистрируется лид в AmoCRM. Требуется подтверждённый email.
   * Создание заявки (1 этап)
   */
  saveDataFirstStage(
    requestParameters: SaveDataFirstStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SaveDataFirstStage200Response>

  /**
   * Сохранение выбранных услуг заявки (4 этап) и создание ордера на оплату. Пустой список разрешён, только если по заявке уже есть оплаченный сервисный продукт (serviceProductPaid из GET stage4); при пустом списке nextStage = APPLICATION_STAGE_7, иначе APPLICATION_STAGE_5. Если по заявке шла предварительная проверка — её последняя история завершается. Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * @summary Выбор услуг заявки (4 этап)
   * @param {string} applicationId Порядковый номер заявления в системе
   * @param {SaveDataFourthStageRequest} saveDataFourthStageRequest Список id выбранных продуктов (не более одного; существующие id из GET stage4)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreateApplicationApiInterface
   */
  saveDataFourthStageRaw(
    requestParameters: SaveDataFourthStageOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UpdateDataFirstStage200Response>>

  /**
   * Сохранение выбранных услуг заявки (4 этап) и создание ордера на оплату. Пустой список разрешён, только если по заявке уже есть оплаченный сервисный продукт (serviceProductPaid из GET stage4); при пустом списке nextStage = APPLICATION_STAGE_7, иначе APPLICATION_STAGE_5. Если по заявке шла предварительная проверка — её последняя история завершается. Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * Выбор услуг заявки (4 этап)
   */
  saveDataFourthStage(
    requestParameters: SaveDataFourthStageOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UpdateDataFirstStage200Response>

  /**
   * Редактирование данных 1 этапа заявки (заказчик/правообладатель, знак). Форма аналогична созданию, но brand/file/imageSignType необязательны. Если по заявке уже шла предварительная проверка — её последняя история завершается. Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). После сохранения nextStage = APPLICATION_STAGE_2. Требуется подтверждённый email. Запрос отправляется методом POST с подменой метода Laravel (query-параметр _method=PATCH); прямой PATCH также принимается роутом.
   * @summary Редактирование 1 этапа заявки
   * @param {string} applicationId Id заявки
   * @param {boolean} isEqual Заказчик и правообладатель совпадают (при true блок owner* запрещён)
   * @param {OrganizationType} customerOrganizationType Тип организации заказчика
   * @param {string} [method] Подмена HTTP-метода Laravel (method spoofing): PATCH — запрос обрабатывается как PATCH
   * @param {string} [customerOrganizationDataInn] ИНН заказчика (10 знаков — юрлицо, 12 — ИП/физлицо)
   * @param {string} [customerOrganizationDataSnils] СНИЛС заказчика (только INDIVIDUAL_ENTITY)
   * @param {string} [customerOrganizationDataPassportSeriesNumber] Серия и номер паспорта заказчика (только INDIVIDUAL_ENTITY)
   * @param {string} [customerOrganizationDataName] Наименование с кратким ОПФ
   * @param {string} [customerOrganizationDataAddress] Адрес с индексом, городом, улицей и квартирой
   * @param {string} [customerOrganizationDataAddressCorrespondent] Адрес для корреспонденции (произвольный формат)
   * @param {string} [customerOrganizationDataNameTransliterate] Транслитерированное наименование (только FOREIGN_COMPANY)
   * @param {string} [customerOrganizationDataRegNumber] Регистрационный номер (только FOREIGN_COMPANY)
   * @param {string} [customerOrganizationDataTaxNumber] Налоговый номер (только FOREIGN_COMPANY)
   * @param {string} [customerOrganizationDataCountryCode] Код страны из словаря (только FOREIGN_COMPANY)
   * @param {string} [customerOrganizationDataAddressTransliterate] Транслитерированный адрес (только FOREIGN_COMPANY)
   * @param {OrganizationType} [ownerOrganizationType] Тип организации правообладателя (обязателен при isEqual&#x3D;false)
   * @param {string} [ownerOrganizationDataInn] ИНН правообладателя; при isEqual&#x3D;true передавать запрещено
   * @param {string} [ownerOrganizationDataSnils] СНИЛС правообладателя (только INDIVIDUAL_ENTITY)
   * @param {string} [ownerOrganizationDataPassportSeriesNumber] Серия и номер паспорта правообладателя (только INDIVIDUAL_ENTITY)
   * @param {string} [ownerOrganizationDataName] Наименование правообладателя с кратким ОПФ
   * @param {string} [ownerOrganizationDataAddress] Адрес правообладателя
   * @param {string} [ownerOrganizationDataAddressCorrespondent] Адрес для корреспонденции правообладателя
   * @param {string} [ownerOrganizationDataNameTransliterate] Транслитерированное наименование (только FOREIGN_COMPANY)
   * @param {string} [ownerOrganizationDataRegNumber] Регистрационный номер (только FOREIGN_COMPANY)
   * @param {string} [ownerOrganizationDataTaxNumber] Налоговый номер (только FOREIGN_COMPANY)
   * @param {string} [ownerOrganizationDataCountryCode] Код страны из словаря (только FOREIGN_COMPANY)
   * @param {string} [ownerOrganizationDataAddressTransliterate] Транслитерированный адрес (только FOREIGN_COMPANY)
   * @param {string} [brand] Словесное наименование знака; исключён с file/imageSignType (при передаче file обязателен их взаимообмен)
   * @param {Blob} [file] Изображение знака (jpg/jpeg/png/tif/tiff/webp)
   * @param {ImageSignType} [imageSignType] Тип знака при загрузке файла: C — комбинированный, D — изобразительный; обязателен при переданном file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreateApplicationApiInterface
   */
  updateDataFirstStageRaw(
    requestParameters: UpdateDataFirstStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UpdateDataFirstStage200Response>>

  /**
   * Редактирование данных 1 этапа заявки (заказчик/правообладатель, знак). Форма аналогична созданию, но brand/file/imageSignType необязательны. Если по заявке уже шла предварительная проверка — её последняя история завершается. Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). После сохранения nextStage = APPLICATION_STAGE_2. Требуется подтверждённый email. Запрос отправляется методом POST с подменой метода Laravel (query-параметр _method=PATCH); прямой PATCH также принимается роутом.
   * Редактирование 1 этапа заявки
   */
  updateDataFirstStage(
    requestParameters: UpdateDataFirstStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UpdateDataFirstStage200Response>

  /**
   * Сохранение классов МКТУ заявки (2 этап): выбранные классы и их наименования товаров/услуг. После сохранения nextStage = APPLICATION_STAGE_3. Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email. Запрос отправляется методом POST с подменой метода Laravel (query-параметр _method=PATCH); прямой PATCH также принимается роутом.
   * @summary Сохранение МКТУ заявки (2 этап)
   * @param {string} applicationId Порядковый номер заявления в системе
   * @param {UpdateDataSecondStageRequest} updateDataSecondStageRequest Список выбранных классов МКТУ (1–45 элементов)
   * @param {string} [method] Подмена HTTP-метода Laravel (method spoofing): PATCH — запрос обрабатывается как PATCH
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreateApplicationApiInterface
   */
  updateDataSecondStageRaw(
    requestParameters: UpdateDataSecondStageOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UpdateDataFirstStage200Response>>

  /**
   * Сохранение классов МКТУ заявки (2 этап): выбранные классы и их наименования товаров/услуг. После сохранения nextStage = APPLICATION_STAGE_3. Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email. Запрос отправляется методом POST с подменой метода Laravel (query-параметр _method=PATCH); прямой PATCH также принимается роутом.
   * Сохранение МКТУ заявки (2 этап)
   */
  updateDataSecondStage(
    requestParameters: UpdateDataSecondStageOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UpdateDataFirstStage200Response>

  /**
   * Загрузка чека об оплате услуг подачи заявки (6 этап, оплата вне платёжного шлюза): заявка блокируется от изменений, создаётся документ чека, запись истории проверок (CHECK_PAYMENT) и входящий платёж во внешнем шлюзе; отправляется служебное уведомление. nextStage = APPLICATION_STAGE_6_5 (обработка чека). Недоступно, пока не обработана предыдущая запись истории проверок. Требуется подтверждённый email.
   * @summary Загрузка чека об оплате (6 этап)
   * @param {string} applicationId Порядковый номер заявления в системе
   * @param {Blob} receipt Файл чека об оплате
   * @param {string} [method] Подмена HTTP-метода Laravel (method spoofing): PATCH — запрос обрабатывается как PATCH
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreateApplicationApiInterface
   */
  uploadReceiptRaw(
    requestParameters: UploadReceiptRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UpdateDataFirstStage200Response>>

  /**
   * Загрузка чека об оплате услуг подачи заявки (6 этап, оплата вне платёжного шлюза): заявка блокируется от изменений, создаётся документ чека, запись истории проверок (CHECK_PAYMENT) и входящий платёж во внешнем шлюзе; отправляется служебное уведомление. nextStage = APPLICATION_STAGE_6_5 (обработка чека). Недоступно, пока не обработана предыдущая запись истории проверок. Требуется подтверждённый email.
   * Загрузка чека об оплате (6 этап)
   */
  uploadReceipt(
    requestParameters: UploadReceiptRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UpdateDataFirstStage200Response>
}

/**
 *
 */
export class CreateApplicationApi
  extends runtime.BaseAPI
  implements CreateApplicationApiInterface
{
  /**
   * Внешнее создание черновика заявки сразу с данными 1 и 2 этапов (заказчик/правообладатель + знак + классы МКТУ) для указанного userUuid. Отсутствует в docs/api.yaml — operationId выбран по кодовой базе. Единственный эндпоинт группы applications без требования подтверждённого email.
   * Внешнее создание черновика заявки
   */
  async createApplicationDraftRaw(
    requestParameters: CreateApplicationDraftRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CreateApplicationDraft200Response>> {
    if (requestParameters['isEqual'] == null) {
      throw new runtime.RequiredError(
        'isEqual',
        'Required parameter "isEqual" was null or undefined when calling createApplicationDraft().'
      )
    }

    if (requestParameters['customerOrganizationType'] == null) {
      throw new runtime.RequiredError(
        'customerOrganizationType',
        'Required parameter "customerOrganizationType" was null or undefined when calling createApplicationDraft().'
      )
    }

    if (requestParameters['mktuList'] == null) {
      throw new runtime.RequiredError(
        'mktuList',
        'Required parameter "mktuList" was null or undefined when calling createApplicationDraft().'
      )
    }

    if (requestParameters['userUuid'] == null) {
      throw new runtime.RequiredError(
        'userUuid',
        'Required parameter "userUuid" was null or undefined when calling createApplicationDraft().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const consumes: runtime.Consume[] = [{ contentType: 'multipart/form-data' }]
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes)

    let formParams: { append(param: string, value: any): any }
    let useForm = false
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm
    if (useForm) {
      formParams = new FormData()
    } else {
      formParams = new URLSearchParams()
    }

    if (requestParameters['isEqual'] != null) {
      formParams.append('isEqual', requestParameters['isEqual'] as any)
    }

    if (requestParameters['customerOrganizationType'] != null) {
      formParams.append(
        'customerOrganizationType',
        requestParameters['customerOrganizationType'] as any
      )
    }

    if (requestParameters['customerOrganizationDataInn'] != null) {
      formParams.append(
        'customerOrganizationData[inn]',
        requestParameters['customerOrganizationDataInn'] as any
      )
    }

    if (requestParameters['customerOrganizationDataSnils'] != null) {
      formParams.append(
        'customerOrganizationData[snils]',
        requestParameters['customerOrganizationDataSnils'] as any
      )
    }

    if (
      requestParameters['customerOrganizationDataPassportSeriesNumber'] != null
    ) {
      formParams.append(
        'customerOrganizationData[passportSeriesNumber]',
        requestParameters['customerOrganizationDataPassportSeriesNumber'] as any
      )
    }

    if (requestParameters['customerOrganizationDataName'] != null) {
      formParams.append(
        'customerOrganizationData[name]',
        requestParameters['customerOrganizationDataName'] as any
      )
    }

    if (requestParameters['customerOrganizationDataAddress'] != null) {
      formParams.append(
        'customerOrganizationData[address]',
        requestParameters['customerOrganizationDataAddress'] as any
      )
    }

    if (
      requestParameters['customerOrganizationDataAddressCorrespondent'] != null
    ) {
      formParams.append(
        'customerOrganizationData[addressCorrespondent]',
        requestParameters['customerOrganizationDataAddressCorrespondent'] as any
      )
    }

    if (
      requestParameters['customerOrganizationDataNameTransliterate'] != null
    ) {
      formParams.append(
        'customerOrganizationData[nameTransliterate]',
        requestParameters['customerOrganizationDataNameTransliterate'] as any
      )
    }

    if (requestParameters['customerOrganizationDataRegNumber'] != null) {
      formParams.append(
        'customerOrganizationData[regNumber]',
        requestParameters['customerOrganizationDataRegNumber'] as any
      )
    }

    if (requestParameters['customerOrganizationDataTaxNumber'] != null) {
      formParams.append(
        'customerOrganizationData[taxNumber]',
        requestParameters['customerOrganizationDataTaxNumber'] as any
      )
    }

    if (requestParameters['customerOrganizationDataCountryCode'] != null) {
      formParams.append(
        'customerOrganizationData[countryCode]',
        requestParameters['customerOrganizationDataCountryCode'] as any
      )
    }

    if (
      requestParameters['customerOrganizationDataAddressTransliterate'] != null
    ) {
      formParams.append(
        'customerOrganizationData[addressTransliterate]',
        requestParameters['customerOrganizationDataAddressTransliterate'] as any
      )
    }

    if (requestParameters['ownerOrganizationType'] != null) {
      formParams.append(
        'ownerOrganizationType',
        requestParameters['ownerOrganizationType'] as any
      )
    }

    if (requestParameters['ownerOrganizationDataInn'] != null) {
      formParams.append(
        'ownerOrganizationData[inn]',
        requestParameters['ownerOrganizationDataInn'] as any
      )
    }

    if (requestParameters['ownerOrganizationDataSnils'] != null) {
      formParams.append(
        'ownerOrganizationData[snils]',
        requestParameters['ownerOrganizationDataSnils'] as any
      )
    }

    if (
      requestParameters['ownerOrganizationDataPassportSeriesNumber'] != null
    ) {
      formParams.append(
        'ownerOrganizationData[passportSeriesNumber]',
        requestParameters['ownerOrganizationDataPassportSeriesNumber'] as any
      )
    }

    if (requestParameters['ownerOrganizationDataName'] != null) {
      formParams.append(
        'ownerOrganizationData[name]',
        requestParameters['ownerOrganizationDataName'] as any
      )
    }

    if (requestParameters['ownerOrganizationDataAddress'] != null) {
      formParams.append(
        'ownerOrganizationData[address]',
        requestParameters['ownerOrganizationDataAddress'] as any
      )
    }

    if (
      requestParameters['ownerOrganizationDataAddressCorrespondent'] != null
    ) {
      formParams.append(
        'ownerOrganizationData[addressCorrespondent]',
        requestParameters['ownerOrganizationDataAddressCorrespondent'] as any
      )
    }

    if (requestParameters['ownerOrganizationDataNameTransliterate'] != null) {
      formParams.append(
        'ownerOrganizationData[nameTransliterate]',
        requestParameters['ownerOrganizationDataNameTransliterate'] as any
      )
    }

    if (requestParameters['ownerOrganizationDataRegNumber'] != null) {
      formParams.append(
        'ownerOrganizationData[regNumber]',
        requestParameters['ownerOrganizationDataRegNumber'] as any
      )
    }

    if (requestParameters['ownerOrganizationDataTaxNumber'] != null) {
      formParams.append(
        'ownerOrganizationData[taxNumber]',
        requestParameters['ownerOrganizationDataTaxNumber'] as any
      )
    }

    if (requestParameters['ownerOrganizationDataCountryCode'] != null) {
      formParams.append(
        'ownerOrganizationData[countryCode]',
        requestParameters['ownerOrganizationDataCountryCode'] as any
      )
    }

    if (
      requestParameters['ownerOrganizationDataAddressTransliterate'] != null
    ) {
      formParams.append(
        'ownerOrganizationData[addressTransliterate]',
        requestParameters['ownerOrganizationDataAddressTransliterate'] as any
      )
    }

    if (requestParameters['brand'] != null) {
      formParams.append('brand', requestParameters['brand'] as any)
    }

    if (requestParameters['file'] != null) {
      formParams.append('file', requestParameters['file'] as any)
    }

    if (requestParameters['imageSignType'] != null) {
      formParams.append(
        'imageSignType',
        requestParameters['imageSignType'] as any
      )
    }

    if (requestParameters['mktuList'] != null) {
      formParams.append(
        'mktuList',
        requestParameters['mktuList']!.join(runtime.COLLECTION_FORMATS['csv'])
      )
    }

    if (requestParameters['userUuid'] != null) {
      formParams.append('userUuid', requestParameters['userUuid'] as any)
    }

    if (requestParameters['allowEmptyPersonalDocuments'] != null) {
      formParams.append(
        'allowEmptyPersonalDocuments',
        requestParameters['allowEmptyPersonalDocuments'] as any
      )
    }

    const response = await this.request(
      {
        path: `/api/v1/applications/draft`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CreateApplicationDraft200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Внешнее создание черновика заявки сразу с данными 1 и 2 этапов (заказчик/правообладатель + знак + классы МКТУ) для указанного userUuid. Отсутствует в docs/api.yaml — operationId выбран по кодовой базе. Единственный эндпоинт группы applications без требования подтверждённого email.
   * Внешнее создание черновика заявки
   */
  async createApplicationDraft(
    requestParameters: CreateApplicationDraftRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CreateApplicationDraft200Response> {
    const response = await this.createApplicationDraftRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Статус последней записи истории проверок заявки (7 этап): статус проверки, признак оплаченной сервисной услуги, ссылка на итоговый документ полной проверки и номер счёта-договора. Статус AGREE_TO_RISKY — искусственный: второй круг после полной проверки, когда услуги на шаге 4 не выбраны (требуется показать предупреждение). Требуется подтверждённый email.
   * Статус проверок заявки (7 этап)
   */
  async getApplicationStatusRaw(
    requestParameters: GetApplicationStatusRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetApplicationStatus200Response>> {
    if (requestParameters['applicationId'] == null) {
      throw new runtime.RequiredError(
        'applicationId',
        'Required parameter "applicationId" was null or undefined when calling getApplicationStatus().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/applications/{applicationId}/stage7/history-status`.replace(
          `{${'applicationId'}}`,
          encodeURIComponent(String(requestParameters['applicationId']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetApplicationStatus200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Статус последней записи истории проверок заявки (7 этап): статус проверки, признак оплаченной сервисной услуги, ссылка на итоговый документ полной проверки и номер счёта-договора. Статус AGREE_TO_RISKY — искусственный: второй круг после полной проверки, когда услуги на шаге 4 не выбраны (требуется показать предупреждение). Требуется подтверждённый email.
   * Статус проверок заявки (7 этап)
   */
  async getApplicationStatus(
    requestParameters: GetApplicationStatusRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetApplicationStatus200Response> {
    const response = await this.getApplicationStatusRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Общее состояние заявки: пройденный и текущий этапы, изображение знака, статистика классов МКТУ, правообладатель, услуги из неоплаченного ордера и признак возможности удаления заявки. Поле linkInAdmin возвращается только админским аккаунтам. Требуется подтверждённый email.
   * Общее состояние заявки
   */
  async getCommonStateRaw(
    requestParameters: GetCommonStateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetCommonState200Response>> {
    if (requestParameters['applicationId'] == null) {
      throw new runtime.RequiredError(
        'applicationId',
        'Required parameter "applicationId" was null or undefined when calling getCommonState().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/applications/{applicationId}/common-state`.replace(
          `{${'applicationId'}}`,
          encodeURIComponent(String(requestParameters['applicationId']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetCommonState200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Общее состояние заявки: пройденный и текущий этапы, изображение знака, статистика классов МКТУ, правообладатель, услуги из неоплаченного ордера и признак возможности удаления заявки. Поле linkInAdmin возвращается только админским аккаунтам. Требуется подтверждённый email.
   * Общее состояние заявки
   */
  async getCommonState(
    requestParameters: GetCommonStateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetCommonState200Response> {
    const response = await this.getCommonStateRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Данные 1 этапа создания заявки: словесный знак либо изображение, признак совпадения заказчика и правообладателя, типы и данные организаций заказчика и правообладателя (схема ApplicationFirstStageData из docs/api.yaml). Состав полей organizationData зависит от типа организации; ненужные для типа поля отсутствуют. Требуется подтверждённый email.
   * Данные 1 этапа заявки
   */
  async getDataFirstStageRaw(
    requestParameters: GetDataFirstStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetDataFirstStage200Response>> {
    if (requestParameters['applicationId'] == null) {
      throw new runtime.RequiredError(
        'applicationId',
        'Required parameter "applicationId" was null or undefined when calling getDataFirstStage().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/applications/{applicationId}/stage1`.replace(
          `{${'applicationId'}}`,
          encodeURIComponent(String(requestParameters['applicationId']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetDataFirstStage200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Данные 1 этапа создания заявки: словесный знак либо изображение, признак совпадения заказчика и правообладателя, типы и данные организаций заказчика и правообладателя (схема ApplicationFirstStageData из docs/api.yaml). Состав полей organizationData зависит от типа организации; ненужные для типа поля отсутствуют. Требуется подтверждённый email.
   * Данные 1 этапа заявки
   */
  async getDataFirstStage(
    requestParameters: GetDataFirstStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetDataFirstStage200Response> {
    const response = await this.getDataFirstStageRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Список услуг, доступных для выбора в заявке (4 этап): группа регистрации (для админских аккаунтов — своя группа) с ценами в базовой валюте. serviceProductPaid=true, если по заявке уже есть оплаченный сервисный продукт — тогда на шаге разрешено не выбирать ни одной услуги. Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * Услуги заявки (4 этап)
   */
  async getDataFourthStageRaw(
    requestParameters: GetDataFourthStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetDataFourthStage200Response>> {
    if (requestParameters['applicationId'] == null) {
      throw new runtime.RequiredError(
        'applicationId',
        'Required parameter "applicationId" was null or undefined when calling getDataFourthStage().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/applications/{applicationId}/stage4`.replace(
          `{${'applicationId'}}`,
          encodeURIComponent(String(requestParameters['applicationId']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetDataFourthStage200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Список услуг, доступных для выбора в заявке (4 этап): группа регистрации (для админских аккаунтов — своя группа) с ценами в базовой валюте. serviceProductPaid=true, если по заявке уже есть оплаченный сервисный продукт — тогда на шаге разрешено не выбирать ни одной услуги. Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * Услуги заявки (4 этап)
   */
  async getDataFourthStage(
    requestParameters: GetDataFourthStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetDataFourthStage200Response> {
    const response = await this.getDataFourthStageRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Классы МКТУ, выбранные в заявке (2 этап): номера классов и наименования товаров/услуг (схема ApplicationSecondStageData из docs/api.yaml). Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * МКТУ заявки (2 этап)
   */
  async getDataSecondStageRaw(
    requestParameters: GetDataSecondStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetDataSecondStage200Response>> {
    if (requestParameters['applicationId'] == null) {
      throw new runtime.RequiredError(
        'applicationId',
        'Required parameter "applicationId" was null or undefined when calling getDataSecondStage().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/applications/{applicationId}/stage2`.replace(
          `{${'applicationId'}}`,
          encodeURIComponent(String(requestParameters['applicationId']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetDataSecondStage200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Классы МКТУ, выбранные в заявке (2 этап): номера классов и наименования товаров/услуг (схема ApplicationSecondStageData из docs/api.yaml). Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * МКТУ заявки (2 этап)
   */
  async getDataSecondStage(
    requestParameters: GetDataSecondStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetDataSecondStage200Response> {
    const response = await this.getDataSecondStageRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Предпросмотр всех данных заявки перед подтверждением подачи (3 этап): знак (brand либо изображение), заказчик/правообладатель и выбранные классы МКТУ (схема ApplicationThirdStageData из docs/api.yaml — данные 1 и 2 этапов вместе). Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * Предпросмотр данных заявки (3 этап)
   */
  async getDataThirdStageRaw(
    requestParameters: GetDataThirdStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetDataThirdStage200Response>> {
    if (requestParameters['applicationId'] == null) {
      throw new runtime.RequiredError(
        'applicationId',
        'Required parameter "applicationId" was null or undefined when calling getDataThirdStage().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/applications/{applicationId}/stage3`.replace(
          `{${'applicationId'}}`,
          encodeURIComponent(String(requestParameters['applicationId']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetDataThirdStage200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Предпросмотр всех данных заявки перед подтверждением подачи (3 этап): знак (brand либо изображение), заказчик/правообладатель и выбранные классы МКТУ (схема ApplicationThirdStageData из docs/api.yaml — данные 1 и 2 этапов вместе). Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * Предпросмотр данных заявки (3 этап)
   */
  async getDataThirdStage(
    requestParameters: GetDataThirdStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetDataThirdStage200Response> {
    const response = await this.getDataThirdStageRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Счёт-договор на оплату услуг подачи заявки (5 этап): PDF-файл отдаётся потоком (Content-Type и имя файла из документа), а не в конверте success_response. Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * Счёт на оплату услуг (PDF)
   */
  async getPaymentDocumentRaw(
    requestParameters: GetPaymentDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>> {
    if (requestParameters['applicationId'] == null) {
      throw new runtime.RequiredError(
        'applicationId',
        'Required parameter "applicationId" was null or undefined when calling getPaymentDocument().'
      )
    }

    const queryParameters: any = {}

    if (requestParameters['type'] != null) {
      queryParameters['type'] = requestParameters['type']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/applications/{applicationId}/stage5/services-payment-document`.replace(
          `{${'applicationId'}}`,
          encodeURIComponent(String(requestParameters['applicationId']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.BlobApiResponse(response)
  }

  /**
   * Счёт-договор на оплату услуг подачи заявки (5 этап): PDF-файл отдаётся потоком (Content-Type и имя файла из документа), а не в конверте success_response. Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * Счёт на оплату услуг (PDF)
   */
  async getPaymentDocument(
    requestParameters: GetPaymentDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob> {
    const response = await this.getPaymentDocumentRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Статус оплаты последнего ордера на услуги подачи заявки (5 этап). Если неоплаченных ордеров нет либо банк подтвердил оплату, isOrderPayed=true и заявка переводится на nextStage = APPLICATION_STAGE_7 (fallback-обработка, если webhook банка ещё не пришёл). Требуется подтверждённый email.
   * Статус оплаты услуг (5 этап)
   */
  async getPaymentStatusRaw(
    requestParameters: GetPaymentStatusRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetPaymentStatus200Response>> {
    if (requestParameters['applicationId'] == null) {
      throw new runtime.RequiredError(
        'applicationId',
        'Required parameter "applicationId" was null or undefined when calling getPaymentStatus().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/applications/{applicationId}/stage5/check-payment-status`.replace(
          `{${'applicationId'}}`,
          encodeURIComponent(String(requestParameters['applicationId']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetPaymentStatus200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Статус оплаты последнего ордера на услуги подачи заявки (5 этап). Если неоплаченных ордеров нет либо банк подтвердил оплату, isOrderPayed=true и заявка переводится на nextStage = APPLICATION_STAGE_7 (fallback-обработка, если webhook банка ещё не пришёл). Требуется подтверждённый email.
   * Статус оплаты услуг (5 этап)
   */
  async getPaymentStatus(
    requestParameters: GetPaymentStatusRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetPaymentStatus200Response> {
    const response = await this.getPaymentStatusRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Ссылка на оплату последнего неоплаченного ордера на услуги подачи заявки (6 этап): через платёжный шлюз, с возвратом на страницу заявки после оплаты. Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * Ссылка на оплату услуг (6 этап)
   */
  async getPaymentUrlRaw(
    requestParameters: GetPaymentUrlRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetPaymentUrl200Response>> {
    if (requestParameters['applicationId'] == null) {
      throw new runtime.RequiredError(
        'applicationId',
        'Required parameter "applicationId" was null or undefined when calling getPaymentUrl().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/applications/{applicationId}/stage6/get-payment-url`.replace(
          `{${'applicationId'}}`,
          encodeURIComponent(String(requestParameters['applicationId']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetPaymentUrl200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Ссылка на оплату последнего неоплаченного ордера на услуги подачи заявки (6 этап): через платёжный шлюз, с возвратом на страницу заявки после оплаты. Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * Ссылка на оплату услуг (6 этап)
   */
  async getPaymentUrl(
    requestParameters: GetPaymentUrlRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetPaymentUrl200Response> {
    const response = await this.getPaymentUrlRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Подтверждение предпросмотра (3 этап пройден): заявка переводится на nextStage = APPLICATION_STAGE_4 (выбор услуг). Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * Подтверждение 3 этапа
   */
  async passThirdStageRaw(
    requestParameters: PassThirdStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UpdateDataFirstStage200Response>> {
    if (requestParameters['applicationId'] == null) {
      throw new runtime.RequiredError(
        'applicationId',
        'Required parameter "applicationId" was null or undefined when calling passThirdStage().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/applications/{applicationId}/stage3/mark-as-passed`.replace(
          `{${'applicationId'}}`,
          encodeURIComponent(String(requestParameters['applicationId']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      UpdateDataFirstStage200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Подтверждение предпросмотра (3 этап пройден): заявка переводится на nextStage = APPLICATION_STAGE_4 (выбор услуг). Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * Подтверждение 3 этапа
   */
  async passThirdStage(
    requestParameters: PassThirdStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UpdateDataFirstStage200Response> {
    const response = await this.passThirdStageRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Публикация заявки в делопроизводство (АРМ) после полной проверки: допускается при статусе последней полной проверки FULL_CHECK_LOW/MEDIUM/HIGH и оплаченной сервисной услуге. Требуется подтверждённый email.
   * Публикация заявки (7 этап)
   */
  async publishApplicationRaw(
    requestParameters: PublishApplicationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PublishApplication200Response>> {
    if (requestParameters['applicationId'] == null) {
      throw new runtime.RequiredError(
        'applicationId',
        'Required parameter "applicationId" was null or undefined when calling publishApplication().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/applications/{applicationId}/stage7/publish-application`.replace(
          `{${'applicationId'}}`,
          encodeURIComponent(String(requestParameters['applicationId']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PublishApplication200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Публикация заявки в делопроизводство (АРМ) после полной проверки: допускается при статусе последней полной проверки FULL_CHECK_LOW/MEDIUM/HIGH и оплаченной сервисной услуге. Требуется подтверждённый email.
   * Публикация заявки (7 этап)
   */
  async publishApplication(
    requestParameters: PublishApplicationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PublishApplication200Response> {
    const response = await this.publishApplicationRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Создание новой заявки: данные заказчика и правообладателя (1 этап) + словесное наименование знака (brand) либо файл изображения (file + imageSignType). При isEqual=true блок правообладателя не передаётся (запрещён). Заявка создаётся сразу со stage1 пройденным, nextStage = APPLICATION_STAGE_2; для не-админских аккаунтов регистрируется лид в AmoCRM. Требуется подтверждённый email.
   * Создание заявки (1 этап)
   */
  async saveDataFirstStageRaw(
    requestParameters: SaveDataFirstStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<SaveDataFirstStage200Response>> {
    if (requestParameters['isEqual'] == null) {
      throw new runtime.RequiredError(
        'isEqual',
        'Required parameter "isEqual" was null or undefined when calling saveDataFirstStage().'
      )
    }

    if (requestParameters['customerOrganizationType'] == null) {
      throw new runtime.RequiredError(
        'customerOrganizationType',
        'Required parameter "customerOrganizationType" was null or undefined when calling saveDataFirstStage().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const consumes: runtime.Consume[] = [{ contentType: 'multipart/form-data' }]
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes)

    let formParams: { append(param: string, value: any): any }
    let useForm = false
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm
    if (useForm) {
      formParams = new FormData()
    } else {
      formParams = new URLSearchParams()
    }

    if (requestParameters['isEqual'] != null) {
      formParams.append('isEqual', requestParameters['isEqual'] as any)
    }

    if (requestParameters['customerOrganizationType'] != null) {
      formParams.append(
        'customerOrganizationType',
        requestParameters['customerOrganizationType'] as any
      )
    }

    if (requestParameters['customerOrganizationDataInn'] != null) {
      formParams.append(
        'customerOrganizationData[inn]',
        requestParameters['customerOrganizationDataInn'] as any
      )
    }

    if (requestParameters['customerOrganizationDataSnils'] != null) {
      formParams.append(
        'customerOrganizationData[snils]',
        requestParameters['customerOrganizationDataSnils'] as any
      )
    }

    if (
      requestParameters['customerOrganizationDataPassportSeriesNumber'] != null
    ) {
      formParams.append(
        'customerOrganizationData[passportSeriesNumber]',
        requestParameters['customerOrganizationDataPassportSeriesNumber'] as any
      )
    }

    if (requestParameters['customerOrganizationDataName'] != null) {
      formParams.append(
        'customerOrganizationData[name]',
        requestParameters['customerOrganizationDataName'] as any
      )
    }

    if (requestParameters['customerOrganizationDataAddress'] != null) {
      formParams.append(
        'customerOrganizationData[address]',
        requestParameters['customerOrganizationDataAddress'] as any
      )
    }

    if (
      requestParameters['customerOrganizationDataAddressCorrespondent'] != null
    ) {
      formParams.append(
        'customerOrganizationData[addressCorrespondent]',
        requestParameters['customerOrganizationDataAddressCorrespondent'] as any
      )
    }

    if (
      requestParameters['customerOrganizationDataNameTransliterate'] != null
    ) {
      formParams.append(
        'customerOrganizationData[nameTransliterate]',
        requestParameters['customerOrganizationDataNameTransliterate'] as any
      )
    }

    if (requestParameters['customerOrganizationDataRegNumber'] != null) {
      formParams.append(
        'customerOrganizationData[regNumber]',
        requestParameters['customerOrganizationDataRegNumber'] as any
      )
    }

    if (requestParameters['customerOrganizationDataTaxNumber'] != null) {
      formParams.append(
        'customerOrganizationData[taxNumber]',
        requestParameters['customerOrganizationDataTaxNumber'] as any
      )
    }

    if (requestParameters['customerOrganizationDataCountryCode'] != null) {
      formParams.append(
        'customerOrganizationData[countryCode]',
        requestParameters['customerOrganizationDataCountryCode'] as any
      )
    }

    if (
      requestParameters['customerOrganizationDataAddressTransliterate'] != null
    ) {
      formParams.append(
        'customerOrganizationData[addressTransliterate]',
        requestParameters['customerOrganizationDataAddressTransliterate'] as any
      )
    }

    if (requestParameters['ownerOrganizationType'] != null) {
      formParams.append(
        'ownerOrganizationType',
        requestParameters['ownerOrganizationType'] as any
      )
    }

    if (requestParameters['ownerOrganizationDataInn'] != null) {
      formParams.append(
        'ownerOrganizationData[inn]',
        requestParameters['ownerOrganizationDataInn'] as any
      )
    }

    if (requestParameters['ownerOrganizationDataSnils'] != null) {
      formParams.append(
        'ownerOrganizationData[snils]',
        requestParameters['ownerOrganizationDataSnils'] as any
      )
    }

    if (
      requestParameters['ownerOrganizationDataPassportSeriesNumber'] != null
    ) {
      formParams.append(
        'ownerOrganizationData[passportSeriesNumber]',
        requestParameters['ownerOrganizationDataPassportSeriesNumber'] as any
      )
    }

    if (requestParameters['ownerOrganizationDataName'] != null) {
      formParams.append(
        'ownerOrganizationData[name]',
        requestParameters['ownerOrganizationDataName'] as any
      )
    }

    if (requestParameters['ownerOrganizationDataAddress'] != null) {
      formParams.append(
        'ownerOrganizationData[address]',
        requestParameters['ownerOrganizationDataAddress'] as any
      )
    }

    if (
      requestParameters['ownerOrganizationDataAddressCorrespondent'] != null
    ) {
      formParams.append(
        'ownerOrganizationData[addressCorrespondent]',
        requestParameters['ownerOrganizationDataAddressCorrespondent'] as any
      )
    }

    if (requestParameters['ownerOrganizationDataNameTransliterate'] != null) {
      formParams.append(
        'ownerOrganizationData[nameTransliterate]',
        requestParameters['ownerOrganizationDataNameTransliterate'] as any
      )
    }

    if (requestParameters['ownerOrganizationDataRegNumber'] != null) {
      formParams.append(
        'ownerOrganizationData[regNumber]',
        requestParameters['ownerOrganizationDataRegNumber'] as any
      )
    }

    if (requestParameters['ownerOrganizationDataTaxNumber'] != null) {
      formParams.append(
        'ownerOrganizationData[taxNumber]',
        requestParameters['ownerOrganizationDataTaxNumber'] as any
      )
    }

    if (requestParameters['ownerOrganizationDataCountryCode'] != null) {
      formParams.append(
        'ownerOrganizationData[countryCode]',
        requestParameters['ownerOrganizationDataCountryCode'] as any
      )
    }

    if (
      requestParameters['ownerOrganizationDataAddressTransliterate'] != null
    ) {
      formParams.append(
        'ownerOrganizationData[addressTransliterate]',
        requestParameters['ownerOrganizationDataAddressTransliterate'] as any
      )
    }

    if (requestParameters['brand'] != null) {
      formParams.append('brand', requestParameters['brand'] as any)
    }

    if (requestParameters['file'] != null) {
      formParams.append('file', requestParameters['file'] as any)
    }

    if (requestParameters['imageSignType'] != null) {
      formParams.append(
        'imageSignType',
        requestParameters['imageSignType'] as any
      )
    }

    const response = await this.request(
      {
        path: `/api/v1/applications`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SaveDataFirstStage200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Создание новой заявки: данные заказчика и правообладателя (1 этап) + словесное наименование знака (brand) либо файл изображения (file + imageSignType). При isEqual=true блок правообладателя не передаётся (запрещён). Заявка создаётся сразу со stage1 пройденным, nextStage = APPLICATION_STAGE_2; для не-админских аккаунтов регистрируется лид в AmoCRM. Требуется подтверждённый email.
   * Создание заявки (1 этап)
   */
  async saveDataFirstStage(
    requestParameters: SaveDataFirstStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<SaveDataFirstStage200Response> {
    const response = await this.saveDataFirstStageRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Сохранение выбранных услуг заявки (4 этап) и создание ордера на оплату. Пустой список разрешён, только если по заявке уже есть оплаченный сервисный продукт (serviceProductPaid из GET stage4); при пустом списке nextStage = APPLICATION_STAGE_7, иначе APPLICATION_STAGE_5. Если по заявке шла предварительная проверка — её последняя история завершается. Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * Выбор услуг заявки (4 этап)
   */
  async saveDataFourthStageRaw(
    requestParameters: SaveDataFourthStageOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UpdateDataFirstStage200Response>> {
    if (requestParameters['applicationId'] == null) {
      throw new runtime.RequiredError(
        'applicationId',
        'Required parameter "applicationId" was null or undefined when calling saveDataFourthStage().'
      )
    }

    if (requestParameters['saveDataFourthStageRequest'] == null) {
      throw new runtime.RequiredError(
        'saveDataFourthStageRequest',
        'Required parameter "saveDataFourthStageRequest" was null or undefined when calling saveDataFourthStage().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/applications/{applicationId}/stage4`.replace(
          `{${'applicationId'}}`,
          encodeURIComponent(String(requestParameters['applicationId']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: SaveDataFourthStageRequestToJSON(
          requestParameters['saveDataFourthStageRequest']
        ),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      UpdateDataFirstStage200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Сохранение выбранных услуг заявки (4 этап) и создание ордера на оплату. Пустой список разрешён, только если по заявке уже есть оплаченный сервисный продукт (serviceProductPaid из GET stage4); при пустом списке nextStage = APPLICATION_STAGE_7, иначе APPLICATION_STAGE_5. Если по заявке шла предварительная проверка — её последняя история завершается. Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email.
   * Выбор услуг заявки (4 этап)
   */
  async saveDataFourthStage(
    requestParameters: SaveDataFourthStageOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UpdateDataFirstStage200Response> {
    const response = await this.saveDataFourthStageRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Редактирование данных 1 этапа заявки (заказчик/правообладатель, знак). Форма аналогична созданию, но brand/file/imageSignType необязательны. Если по заявке уже шла предварительная проверка — её последняя история завершается. Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). После сохранения nextStage = APPLICATION_STAGE_2. Требуется подтверждённый email. Запрос отправляется методом POST с подменой метода Laravel (query-параметр _method=PATCH); прямой PATCH также принимается роутом.
   * Редактирование 1 этапа заявки
   */
  async updateDataFirstStageRaw(
    requestParameters: UpdateDataFirstStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UpdateDataFirstStage200Response>> {
    if (requestParameters['applicationId'] == null) {
      throw new runtime.RequiredError(
        'applicationId',
        'Required parameter "applicationId" was null or undefined when calling updateDataFirstStage().'
      )
    }

    if (requestParameters['isEqual'] == null) {
      throw new runtime.RequiredError(
        'isEqual',
        'Required parameter "isEqual" was null or undefined when calling updateDataFirstStage().'
      )
    }

    if (requestParameters['customerOrganizationType'] == null) {
      throw new runtime.RequiredError(
        'customerOrganizationType',
        'Required parameter "customerOrganizationType" was null or undefined when calling updateDataFirstStage().'
      )
    }

    const queryParameters: any = {}

    if (requestParameters['method'] != null) {
      queryParameters['_method'] = requestParameters['method']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const consumes: runtime.Consume[] = [{ contentType: 'multipart/form-data' }]
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes)

    let formParams: { append(param: string, value: any): any }
    let useForm = false
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm
    if (useForm) {
      formParams = new FormData()
    } else {
      formParams = new URLSearchParams()
    }

    if (requestParameters['isEqual'] != null) {
      formParams.append('isEqual', requestParameters['isEqual'] as any)
    }

    if (requestParameters['customerOrganizationType'] != null) {
      formParams.append(
        'customerOrganizationType',
        requestParameters['customerOrganizationType'] as any
      )
    }

    if (requestParameters['customerOrganizationDataInn'] != null) {
      formParams.append(
        'customerOrganizationData[inn]',
        requestParameters['customerOrganizationDataInn'] as any
      )
    }

    if (requestParameters['customerOrganizationDataSnils'] != null) {
      formParams.append(
        'customerOrganizationData[snils]',
        requestParameters['customerOrganizationDataSnils'] as any
      )
    }

    if (
      requestParameters['customerOrganizationDataPassportSeriesNumber'] != null
    ) {
      formParams.append(
        'customerOrganizationData[passportSeriesNumber]',
        requestParameters['customerOrganizationDataPassportSeriesNumber'] as any
      )
    }

    if (requestParameters['customerOrganizationDataName'] != null) {
      formParams.append(
        'customerOrganizationData[name]',
        requestParameters['customerOrganizationDataName'] as any
      )
    }

    if (requestParameters['customerOrganizationDataAddress'] != null) {
      formParams.append(
        'customerOrganizationData[address]',
        requestParameters['customerOrganizationDataAddress'] as any
      )
    }

    if (
      requestParameters['customerOrganizationDataAddressCorrespondent'] != null
    ) {
      formParams.append(
        'customerOrganizationData[addressCorrespondent]',
        requestParameters['customerOrganizationDataAddressCorrespondent'] as any
      )
    }

    if (
      requestParameters['customerOrganizationDataNameTransliterate'] != null
    ) {
      formParams.append(
        'customerOrganizationData[nameTransliterate]',
        requestParameters['customerOrganizationDataNameTransliterate'] as any
      )
    }

    if (requestParameters['customerOrganizationDataRegNumber'] != null) {
      formParams.append(
        'customerOrganizationData[regNumber]',
        requestParameters['customerOrganizationDataRegNumber'] as any
      )
    }

    if (requestParameters['customerOrganizationDataTaxNumber'] != null) {
      formParams.append(
        'customerOrganizationData[taxNumber]',
        requestParameters['customerOrganizationDataTaxNumber'] as any
      )
    }

    if (requestParameters['customerOrganizationDataCountryCode'] != null) {
      formParams.append(
        'customerOrganizationData[countryCode]',
        requestParameters['customerOrganizationDataCountryCode'] as any
      )
    }

    if (
      requestParameters['customerOrganizationDataAddressTransliterate'] != null
    ) {
      formParams.append(
        'customerOrganizationData[addressTransliterate]',
        requestParameters['customerOrganizationDataAddressTransliterate'] as any
      )
    }

    if (requestParameters['ownerOrganizationType'] != null) {
      formParams.append(
        'ownerOrganizationType',
        requestParameters['ownerOrganizationType'] as any
      )
    }

    if (requestParameters['ownerOrganizationDataInn'] != null) {
      formParams.append(
        'ownerOrganizationData[inn]',
        requestParameters['ownerOrganizationDataInn'] as any
      )
    }

    if (requestParameters['ownerOrganizationDataSnils'] != null) {
      formParams.append(
        'ownerOrganizationData[snils]',
        requestParameters['ownerOrganizationDataSnils'] as any
      )
    }

    if (
      requestParameters['ownerOrganizationDataPassportSeriesNumber'] != null
    ) {
      formParams.append(
        'ownerOrganizationData[passportSeriesNumber]',
        requestParameters['ownerOrganizationDataPassportSeriesNumber'] as any
      )
    }

    if (requestParameters['ownerOrganizationDataName'] != null) {
      formParams.append(
        'ownerOrganizationData[name]',
        requestParameters['ownerOrganizationDataName'] as any
      )
    }

    if (requestParameters['ownerOrganizationDataAddress'] != null) {
      formParams.append(
        'ownerOrganizationData[address]',
        requestParameters['ownerOrganizationDataAddress'] as any
      )
    }

    if (
      requestParameters['ownerOrganizationDataAddressCorrespondent'] != null
    ) {
      formParams.append(
        'ownerOrganizationData[addressCorrespondent]',
        requestParameters['ownerOrganizationDataAddressCorrespondent'] as any
      )
    }

    if (requestParameters['ownerOrganizationDataNameTransliterate'] != null) {
      formParams.append(
        'ownerOrganizationData[nameTransliterate]',
        requestParameters['ownerOrganizationDataNameTransliterate'] as any
      )
    }

    if (requestParameters['ownerOrganizationDataRegNumber'] != null) {
      formParams.append(
        'ownerOrganizationData[regNumber]',
        requestParameters['ownerOrganizationDataRegNumber'] as any
      )
    }

    if (requestParameters['ownerOrganizationDataTaxNumber'] != null) {
      formParams.append(
        'ownerOrganizationData[taxNumber]',
        requestParameters['ownerOrganizationDataTaxNumber'] as any
      )
    }

    if (requestParameters['ownerOrganizationDataCountryCode'] != null) {
      formParams.append(
        'ownerOrganizationData[countryCode]',
        requestParameters['ownerOrganizationDataCountryCode'] as any
      )
    }

    if (
      requestParameters['ownerOrganizationDataAddressTransliterate'] != null
    ) {
      formParams.append(
        'ownerOrganizationData[addressTransliterate]',
        requestParameters['ownerOrganizationDataAddressTransliterate'] as any
      )
    }

    if (requestParameters['brand'] != null) {
      formParams.append('brand', requestParameters['brand'] as any)
    }

    if (requestParameters['file'] != null) {
      formParams.append('file', requestParameters['file'] as any)
    }

    if (requestParameters['imageSignType'] != null) {
      formParams.append(
        'imageSignType',
        requestParameters['imageSignType'] as any
      )
    }

    const response = await this.request(
      {
        path: `/api/v1/applications/{applicationId}/stage1`.replace(
          `{${'applicationId'}}`,
          encodeURIComponent(String(requestParameters['applicationId']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      UpdateDataFirstStage200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Редактирование данных 1 этапа заявки (заказчик/правообладатель, знак). Форма аналогична созданию, но brand/file/imageSignType необязательны. Если по заявке уже шла предварительная проверка — её последняя история завершается. Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). После сохранения nextStage = APPLICATION_STAGE_2. Требуется подтверждённый email. Запрос отправляется методом POST с подменой метода Laravel (query-параметр _method=PATCH); прямой PATCH также принимается роутом.
   * Редактирование 1 этапа заявки
   */
  async updateDataFirstStage(
    requestParameters: UpdateDataFirstStageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UpdateDataFirstStage200Response> {
    const response = await this.updateDataFirstStageRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Сохранение классов МКТУ заявки (2 этап): выбранные классы и их наименования товаров/услуг. После сохранения nextStage = APPLICATION_STAGE_3. Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email. Запрос отправляется методом POST с подменой метода Laravel (query-параметр _method=PATCH); прямой PATCH также принимается роутом.
   * Сохранение МКТУ заявки (2 этап)
   */
  async updateDataSecondStageRaw(
    requestParameters: UpdateDataSecondStageOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UpdateDataFirstStage200Response>> {
    if (requestParameters['applicationId'] == null) {
      throw new runtime.RequiredError(
        'applicationId',
        'Required parameter "applicationId" was null or undefined when calling updateDataSecondStage().'
      )
    }

    if (requestParameters['updateDataSecondStageRequest'] == null) {
      throw new runtime.RequiredError(
        'updateDataSecondStageRequest',
        'Required parameter "updateDataSecondStageRequest" was null or undefined when calling updateDataSecondStage().'
      )
    }

    const queryParameters: any = {}

    if (requestParameters['method'] != null) {
      queryParameters['_method'] = requestParameters['method']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/applications/{applicationId}/stage2`.replace(
          `{${'applicationId'}}`,
          encodeURIComponent(String(requestParameters['applicationId']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: UpdateDataSecondStageRequestToJSON(
          requestParameters['updateDataSecondStageRequest']
        ),
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      UpdateDataFirstStage200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Сохранение классов МКТУ заявки (2 этап): выбранные классы и их наименования товаров/услуг. После сохранения nextStage = APPLICATION_STAGE_3. Недоступно для заявок, заблокированных от изменений (LockedToChangeMiddleware). Требуется подтверждённый email. Запрос отправляется методом POST с подменой метода Laravel (query-параметр _method=PATCH); прямой PATCH также принимается роутом.
   * Сохранение МКТУ заявки (2 этап)
   */
  async updateDataSecondStage(
    requestParameters: UpdateDataSecondStageOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UpdateDataFirstStage200Response> {
    const response = await this.updateDataSecondStageRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Загрузка чека об оплате услуг подачи заявки (6 этап, оплата вне платёжного шлюза): заявка блокируется от изменений, создаётся документ чека, запись истории проверок (CHECK_PAYMENT) и входящий платёж во внешнем шлюзе; отправляется служебное уведомление. nextStage = APPLICATION_STAGE_6_5 (обработка чека). Недоступно, пока не обработана предыдущая запись истории проверок. Требуется подтверждённый email.
   * Загрузка чека об оплате (6 этап)
   */
  async uploadReceiptRaw(
    requestParameters: UploadReceiptRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UpdateDataFirstStage200Response>> {
    if (requestParameters['applicationId'] == null) {
      throw new runtime.RequiredError(
        'applicationId',
        'Required parameter "applicationId" was null or undefined when calling uploadReceipt().'
      )
    }

    if (requestParameters['receipt'] == null) {
      throw new runtime.RequiredError(
        'receipt',
        'Required parameter "receipt" was null or undefined when calling uploadReceipt().'
      )
    }

    const queryParameters: any = {}

    if (requestParameters['method'] != null) {
      queryParameters['_method'] = requestParameters['method']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const consumes: runtime.Consume[] = [{ contentType: 'multipart/form-data' }]
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes)

    let formParams: { append(param: string, value: any): any }
    let useForm = false
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm
    if (useForm) {
      formParams = new FormData()
    } else {
      formParams = new URLSearchParams()
    }

    if (requestParameters['receipt'] != null) {
      formParams.append('receipt', requestParameters['receipt'] as any)
    }

    const response = await this.request(
      {
        path: `/api/v1/applications/{applicationId}/stage6/upload-receipt`.replace(
          `{${'applicationId'}}`,
          encodeURIComponent(String(requestParameters['applicationId']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      UpdateDataFirstStage200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Загрузка чека об оплате услуг подачи заявки (6 этап, оплата вне платёжного шлюза): заявка блокируется от изменений, создаётся документ чека, запись истории проверок (CHECK_PAYMENT) и входящий платёж во внешнем шлюзе; отправляется служебное уведомление. nextStage = APPLICATION_STAGE_6_5 (обработка чека). Недоступно, пока не обработана предыдущая запись истории проверок. Требуется подтверждённый email.
   * Загрузка чека об оплате (6 этап)
   */
  async uploadReceipt(
    requestParameters: UploadReceiptRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UpdateDataFirstStage200Response> {
    const response = await this.uploadReceiptRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }
}

/**
 * @export
 * @enum {string}
 */
export enum GetPaymentDocumentTypeEnum {
  Inline = 'inline',
  Attachment = 'attachment',
}
